//import Logout from './screens/index.vue';
const Logout = () => import('./screens/index.vue')

const logoutRoutes = [
  {
    path: '/sair',
    name: 'Sair',
    component: Logout,
    meta: {
      requiresAuth: true,
      hideFromMenu: true,
    },
  },
];

export { logoutRoutes };

